import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToCastAndCrew = {
  [titleId: string]: WpsTypes.atv.wps.CastAndCrewWidgetModelProps | undefined
}

export const reducer = createMergeReducer(
  t => t.castAndCrew,
  {} as TitleIdToCastAndCrew
)